import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

type PaginationState = {
    limit: number;
    offset: number;
};
type PaginationActions = {
    setLimit: (limit: number) => void;
    setOffset: (offset: number) => void;
};
export function useLimitOffsetPagination(): [PaginationState, PaginationActions] {
    const [params, setParams] = useSearchParams();

    const limit = parseInt(params.get("limit") ?? "20", 10);
    const offset = parseInt(params.get("offset") ?? "0", 10);

    const setLimit = useCallback(
        (limit: number) => {
            setParams({ limit: limit.toString() }, { replace: true });
        },
        [setParams]
    );
    const setOffset = useCallback(
        (offset: number) => {
            setParams({ offset: offset.toString() }, { replace: true });
        },
        [setParams]
    );

    return [
        { limit, offset },
        { setLimit, setOffset },
    ];
}
